import { render, staticRenderFns } from "./FormTan.vue?vue&type=template&id=78b3d2f5&"
import script from "./FormTan.vue?vue&type=script&lang=js&"
export * from "./FormTan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports